import translate from '../../constants/translate';
import { Descriptions, DescriptionsProps } from 'antd';

export default function Overview({ admin }: any) {
    const items: DescriptionsProps['items'] = [
        {
            key: '1',
            label: 'Họ',
            children: admin?.last_name,
        },
        {
            key: '2',
            label: 'Tên',
            children: admin?.first_name,
        },
        {
            key: '3',
            label: translate.username,
            children: admin?.username,
        },
        {
            key: '4',
            label: translate.email,
            children: admin?.email,
        },
        {
            key: '5',
            label: translate.country,
            children: admin?.country,
        },
        // {
        //     key: '6',
        //     label: translate.mobile,
        //     children: admin?.mobile,
        //     span: 3,
        // },
        {
            key: '7',
            label: translate.address,
            children: admin?.address,
        },
    ];
    return <div>
        <Descriptions
            items={items}
            column={2}
            title={
                <span style={{ fontWeight: 400 }}>
                    Nhóm quản trị: <b>Admin</b>
                </span>}
        />
    </div>
}
